var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/has.js
// module id = UBUE
// module chunks = 0